import React from 'react';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import * as ST from './styled';

interface IProps {
    children: JSX.Element[],
    slideIndex?: number,
}

/**
 * Слайдер с фиксом для прокрутки к указанному слайду
 * используется для минифицированных карточек тарифов с выбором тарифа
 */
// todo: разобраться зачем нужен
export const CustomSwiper = ({ slideIndex = 0, children }: IProps): JSX.Element => {
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    return (
        <ST.CustomSwiper
            slideIndex={slideIndex === -1 ? 0 : slideIndex}
            withoutDots
            withoutArrows={true}
            slideWidth={isMobile ? 148 : 190}
            cellSpacing={isMobile ? 12 : 18}
            slidesToScroll={'auto'}
            disableEdgeSwiping={true}
            cursorType={'pointer'}
            framePadding={'0 0 0 0'}
        >
            {React.Children.map(children, (child) => child)}
        </ST.CustomSwiper>
    );
};
